export function getBlogSlug(blog) {
  const baseSlug = (blog?.title || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/&/g, " and ")
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/[-\s]+/g, "-");

  const safeSlug = baseSlug || `blog-${blog?.id ?? "item"}`;
  return `${safeSlug}-${blog?.id ?? "item"}`;
}

export function getBlogPath(blog, pathname = "") {
  const prefix = pathname.startsWith("/he") ? "/he" : "";
  return `${prefix}/blog/${getBlogSlug(blog)}`;
}

export function getBlogTitle(blog, pathname = "") {
  if (pathname.startsWith("/he") && blog?.titleHe) {
    return blog.titleHe;
  }

  return blog?.title || "";
}

export function findBlogBySlug(blogs, slug) {
  return blogs.find((blog) => getBlogSlug(blog) === slug) || null;
}
